import EducationInfoForm from './EducationInfoForm';

export default EducationInfoForm;
